import { CreateRecipeActions } from "../reducers/CreateRecipeReducer";

export const createRecipeAction = (): CreateRecipeActions => ({
	type: "CREATE_RECIPE"
});

export const clearCreateRecipe = (): CreateRecipeActions => ({
	type: "CLEAR_CREATE_RECIPE"
});